import { render, staticRenderFns } from "./ClinicPayment.vue?vue&type=template&id=3dfbaf2d"
import script from "./ClinicPayment.vue?vue&type=script&lang=js"
export * from "./ClinicPayment.vue?vue&type=script&lang=js"
import style0 from "./ClinicPayment.vue?vue&type=style&index=0&id=3dfbaf2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports